import authHelper from '@/helpers/authSupplier';

export default {
	noAuth(config) {
		return config;
	},

	auth(config) {
		const token = authHelper.getToken();
		config.headers.Authorization = `Bearer ${token}`;

		return config;
	},

	onError(err) {
		return Promise.reject(err);
	},
};
